// extracted by mini-css-extract-plugin
module.exports = {"javneNabavke":"JavneNabavke_javneNabavke__2P8TP","title":"JavneNabavke_title__3QsuU","icon":"JavneNabavke_icon__jCX0Q"};